import React, { createContext, useContext } from "react";
import { useUIService } from "../services/ui.service";
import { ToasterFacadeProvider } from "./toaster.facade";

let operationsAllowed: any = {};
const UIFacadeContext = createContext(operationsAllowed);

export const UIFacadeProvider = (props: any) => {
  const uiService = useUIService();

  const showConfirmDeletePopup = (event: any, data: any, acceptFunction: Function,  rejectFunction?: Function, message?: string) => {
    uiService.showConfirmDeletePopup(event, data, acceptFunction, rejectFunction, message);
  };

  const showConfirmDeleteDialog = (data: any, acceptFunction: Function,  rejectFunction?: Function, message?: string) => {
    uiService.showConfirmDeleteDialog(data, acceptFunction, rejectFunction, message);
  };

  operationsAllowed = {
    showConfirmDeletePopup,
    showConfirmDeleteDialog
  };

  return (
    <UIFacadeContext.Provider value={operationsAllowed}>
      <ToasterFacadeProvider>{props.children}</ToasterFacadeProvider>
    </UIFacadeContext.Provider>
  );
};

export const useUIFacade = () => {
  return useContext(UIFacadeContext);
};
